import { apiClient } from '../config/api';

// FEAT-059 (MVP-18.37) — admin client for the generic, key-addressed runtime
// feature-flag surface mounted at /feature-flags. Distinct from the legacy
// `featureFlagsService` (typed `/features` create_account_enabled flag). These
// flags let admins enable/disable features at runtime without a deployment.

export interface FeatureFlag {
  id: string;
  key: string;
  enabled: boolean;
  description: string | null;
  createdAt: string;
  updatedAt: string;
}

class FeatureFlagService {
  async listFlags(): Promise<FeatureFlag[]> {
    const response = await apiClient.get<{ flags: FeatureFlag[] }>('/feature-flags');
    return response.data.flags ?? [];
  }

  async setFlag(key: string, enabled: boolean, description?: string): Promise<FeatureFlag> {
    const body: { enabled: boolean; description?: string } = { enabled };
    if (description !== undefined) {
      body.description = description;
    }
    const response = await apiClient.put<{ flag: FeatureFlag }>(
      `/feature-flags/${encodeURIComponent(key)}`,
      body
    );
    return response.data.flag;
  }
}

export const featureFlagService = new FeatureFlagService();
